import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { checkType, checkAllValues, filterConfigExtraValues } from '../helper/utils/common';
import { getVersion } from '../helper/utils';
import { arrayToString } from '../helper/utils/common';
import { getOS, getBroswerIsMobile } from '../helper/utils/device';
import getSystemData from '../module/getSystemData';
/**
 * 整合要上传的数据
 * @param {object} config 用户配置
 * @param {object} values getAllData返回的数据
 */

export var getRearrangeData = function getRearrangeData(_ref) {
  var _rtcRes$ethip, _objectSpread2;

  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values;
  var deviceValues,
      locationInfo,
      broswer,
      sys_feature,
      conn,
      sd_ext,
      resolution,
      sup,
      posRes = values.positionResponse || {},
      //地理位置
  fpRes = values.fingerprintResponse || {},
      //获取fingerprint2字段
  enumerateRes = values.enumerateDevicesResponse || '',
      //设备枚举
  nativeFpRes = values.nativeFingerprintResponse || {},
      //手机设备信息
  webglRes = values.webglAttributeResponse || {},
      //webgl属性信息
  fontsRes = values.fontsDisplayResponse || {},
      //字体显示信息
  rtcRes = values.rtcConnectResponse || [],
      //rtc返回值,ipv4 ipv6
  batRes = values.batteryResponse || {},
      privateRes = values.privateResponse || false,
      localCacheRes = values.localCacheResponse || false,
      networkIPRes = values.networkIPResponse || '',
      smDeviceIdRes = values.smDeviceIdResponse || '',
      systemData = getSystemData();
  locationInfo = {
    longitude: (posRes === null || posRes === void 0 ? void 0 : posRes.lo) || -0.0,
    latitude: (posRes === null || posRes === void 0 ? void 0 : posRes.la) || -0.0,
    time_zone: checkType(fpRes.timezone, 'string'),
    time_zone_offset: checkType(fpRes.timezoneOffset, 'number')
  };
  broswer = {
    language: checkType(fpRes.language, 'string'),
    user_agent: checkType(fpRes.userAgent, 'string'),
    plugins: fpRes.plugins && fpRes.plugins.length > 0 ? arrayToString(fpRes.plugins.reduce(function (r, item) {
      return r.concat(item);
    }, [])) : '',
    // fpRes.plugins && fpRes.plugins.length > 0
    //   ? arrayToString(fpRes.plugins.flat(Infinity))
    //   : '', //爬虫不支持flat
    platform: arrayToString(fpRes.platform, 'string'),
    hardware_concurrency: checkType(fpRes.hardwareConcurrency, 'number'),
    web_driver: fpRes.webdriver === 'not available' || !fpRes.webdriver ? 'undefined' : 'true',
    is_move: 0,
    accept: '',
    //后端
    accept_encoding: '',
    //后端
    accept_language: '',
    //后端
    referer: '',
    //后端
    //1.0新增
    brow_conm: checkType(navigator.appCodeName || '', 'string'),
    brow_nm: checkType(navigator.appName || '', 'string'),
    sup_css: systemData.cssSupport,
    touch: systemData.isHaveOntouch,
    can_win: systemData.canvasRect.winding,
    nm: systemData.isNightmare,
    is_ph: systemData.isPhantom
  };
  conn = {
    net_1: checkType(systemData.connection.effectiveType, 'string'),
    net_dl: checkType(systemData.connection.downlink, 'string'),
    net_dlmax: checkType(systemData.connection.downlinkMax, 'string'),
    net_rtt: checkType(systemData.connection.rtt, 'string'),
    net_savedata: checkType(systemData.connection.saveData, 'string'),
    net_2: checkType(systemData.connection.type, 'string')
  };
  sd_ext = {
    battery: checkType(batRes.level, 'string'),
    audio_1: systemData.audio,
    code_length: getSystemData.toString().length || -1,
    //新增的system属性函数长度
    dl: systemData.dateLocale,
    exp_tan: systemData.math,
    privacy: privateRes,
    fonts_support: systemData.fonts,
    ctrects: systemData.clientRects,
    is_orichange: systemData.orientation.prop,
    permission: systemData.permissions,
    the_forks: systemData.fakeProfile,
    glyphs: systemData.glyphs,
    se: systemData.selenium,
    sds: localCacheRes,
    //systemData.randomString
    rtc_ip: checkType((rtcRes === null || rtcRes === void 0 ? void 0 : rtcRes.rtc_ip) ? rtcRes.rtc_ip.join(',') : '', 'string'),
    sm_device_id: smDeviceIdRes
  };
  sys_feature = {
    session_storage: checkType(fpRes.sessionStorage, 'boolean'),
    local_storage: checkType(fpRes.localStorage, 'boolean'),
    indexed_db: checkType(fpRes.indexedDb, 'boolean'),
    add_behavior: checkType(fpRes.addBehavior, 'boolean'),
    open_database: checkType(fpRes.openDatabase, 'boolean'),
    ad_block: checkType(fpRes.adBlock, 'boolean'),
    has_lied_languages: checkType(fpRes.hasLiedLanguages, 'boolean'),
    has_lied_resolution: checkType(fpRes.hasLiedResolution, 'boolean'),
    has_lied_os: checkType(fpRes.hasLiedOs, 'boolean'),
    has_lied_browser: checkType(fpRes.hasLiedBrowser, 'boolean'),
    touch_support: checkType(fpRes.touchSupport, 'boolean'),
    do_not_track: checkType(navigator.doNotTrack, 'boolean')
  };
  resolution = {
    screen_resolution: checkType(fpRes.screenResolution, 'array|int'),
    available_screen_resolution: checkType(fpRes.availableScreenResolution, 'array|int'),
    scr_x: checkType(systemData.screenLeft, 'string'),
    display: checkType(systemData.bodyClient, 'array|int'),
    scr_dir: systemData.orientation.val
  };
  sup = {
    webgl_mvd: systemData.webglMvd,
    offset_width: systemData.offsetWidth,
    gen_error: systemData.genError,
    ca_sup: systemData.createAnalyser,
    gh_sup: systemData.offsetHeight,
    td_sup: systemData.canvasToDataUrl,
    rtcpc_sup: systemData.rtc,
    ed_sup: systemData.enumerateDevices,
    w_tostring: systemData.windowToString,
    wsocket: systemData.websocketError
  };
  deviceValues = _objectSpread(_objectSpread({
    app_id: getBroswerIsMobile() ? '001' : '005'
  }, filterConfigExtraValues(config)), {}, (_objectSpread2 = {
    sdk_version: getVersion(),
    device_id: fpRes.device_id,
    uuid: '',
    location: locationInfo
  }, _defineProperty(_objectSpread2, "device_id", checkType(fpRes.fingerprint2Murmur, 'string')), _defineProperty(_objectSpread2, "broswer", broswer), _defineProperty(_objectSpread2, "conn", conn), _defineProperty(_objectSpread2, "sd_ext", sd_ext), _defineProperty(_objectSpread2, "sys_feature", sys_feature), _defineProperty(_objectSpread2, "resolution", resolution), _defineProperty(_objectSpread2, "sup", sup), _defineProperty(_objectSpread2, "os", checkType(getOS(), 'string')), _defineProperty(_objectSpread2, "color_depth", checkType(fpRes.colorDepth, 'number')), _defineProperty(_objectSpread2, "canvas", checkType(arrayToString(fpRes.canvas), 'string')), _defineProperty(_objectSpread2, "webgl", checkType(arrayToString(fpRes.webgl), 'string')), _defineProperty(_objectSpread2, "webgl_vendor_renderer", checkType(fpRes.webglVendorAndRenderer, 'string')), _defineProperty(_objectSpread2, "device_memory", checkType(fpRes.deviceMemory, 'number')), _defineProperty(_objectSpread2, "pixel_ration", window.devicePixelRatio ? checkType(window.devicePixelRatio, 'number') : -1), _defineProperty(_objectSpread2, "cpu_class", checkType(fpRes.cpuClass, 'string')), _defineProperty(_objectSpread2, "fonts", checkType(arrayToString(fpRes.fonts), 'string')), _defineProperty(_objectSpread2, "fonts_flash", checkType(arrayToString(systemData.fontFlash), 'string')), _defineProperty(_objectSpread2, "audio", checkType(fpRes.audio, 'float')), _defineProperty(_objectSpread2, "post_timestamp", new Date().getTime()), _defineProperty(_objectSpread2, "adjust_timestamp", new Date().getTime()), _defineProperty(_objectSpread2, "native_fingerprint", checkType(nativeFpRes.device_finger_print ? _JSON$stringify(nativeFpRes.device_finger_print) : '', 'string')), _defineProperty(_objectSpread2, "enumerate_devices", checkType(enumerateRes, 'string')), _defineProperty(_objectSpread2, "webgl_attribute", (webglRes === null || webglRes === void 0 ? void 0 : webglRes.hash) || {}), _defineProperty(_objectSpread2, "font_display", fontsRes || {}), _defineProperty(_objectSpread2, "ethIp", checkType((_rtcRes$ethip = rtcRes === null || rtcRes === void 0 ? void 0 : rtcRes.ethip) !== null && _rtcRes$ethip !== void 0 ? _rtcRes$ethip : '', 'string')), _defineProperty(_objectSpread2, "ipv6", checkType(rtcRes === null || rtcRes === void 0 ? void 0 : rtcRes.ipv6, 'string')), _objectSpread2)); //删除多余字段

  delete deviceValues.time_zone;
  delete deviceValues.time_zone_offset;
  return deviceValues;
};